import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "./ui/card";
import { Button } from "./ui/button";

/**
 * Catch-all page for unknown routes. Renders inside the normal app shell.
 * @param {Object} props
 * @param {number} [props.userId]
 * @returns {JSX.Element}
 */
export default function NotFoundPage({ userId }) {
  const location = useLocation();
  const homePath = userId ? "/feed" : "/";
  const homeLabel = userId ? "Go to feed" : "Go home";

  return (
    <div className="mx-auto max-w-lg px-4 py-10">
      <Card>
        <CardHeader>
          <CardTitle className="font-display text-2xl font-medium">Page not found</CardTitle>
          <CardDescription>
            That link doesn’t match any page in Assembly. Check the URL or head somewhere familiar.
          </CardDescription>
        </CardHeader>
        <CardContent className="flex flex-col gap-3">
          {location.pathname ? (
            <p className="rounded-md border border-ui-border bg-ui-background px-3 py-2 font-mono text-xs text-text-muted break-all">
              {location.pathname}
            </p>
          ) : null}
          <Button asChild>
            <Link to={homePath}>{homeLabel}</Link>
          </Button>
          <Button asChild variant="outline">
            <Link to="/explore">Explore</Link>
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
